import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../store/index';
import { getIsEditModeEnabled } from '../../store/FMTree/FMTReeSelectors';
import { TreeDisplayStateType, TreeNodeType, GeofenceType, TreeType } from '../../store/FMTree/FMTreeReducer';
import { showGeofenceOnMap } from '../../features/FMMap/FMMapActions';
import { fetchGeotreeNodeData, fetchGeotreeNewNodeData, deleteSelectedNode, isAllowEditGeoTree } from '../../store/FMTree/FMTreeActions';

interface OwnProps {
    treeDisplayState: TreeDisplayStateType;
}

interface StateProps {
    editModeEnabled: boolean;
    allowEditGeoTree: boolean;
}

interface DispatchStateProps {
    showGeofenceOnMap: () => void;
    fetchGeotreeNodeData: (param: boolean) => void;
    fetchGeotreeNewNodeData: (treeNodeType: TreeNodeType, geofenceType?: GeofenceType) => void;
    deleteSelectedNode: (treeType: TreeType, treeDisplayState: TreeDisplayStateType) => void;
}

export type Props = OwnProps & StateProps & DispatchStateProps;

const FMGeofenceActionsContainer = (Component: any ) => {
    return class extends React.PureComponent<Props> { 
        public render() {
            return (                           
                  <Component {...this.props} />
            ) 
        }
    }
};

const mapStateToProps = (state: RootState, ownProps: OwnProps ): StateProps => ({
    editModeEnabled: getIsEditModeEnabled(state, ownProps.treeDisplayState),
    allowEditGeoTree: isAllowEditGeoTree()
});

const mapDispatchToProps = {
    showGeofenceOnMap,
    fetchGeotreeNodeData,
    fetchGeotreeNewNodeData,
    deleteSelectedNode
};

const composedTreeEditModeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    FMGeofenceActionsContainer
);

export default composedTreeEditModeContainer;
